import { useId } from 'react';

import clsx from 'clsx';

import styles from './Arrow.module.scss';

type ArrowProps = {
  lineMaskRef: React.RefObject<SVGPathElement | null>;
  arrowMaskRef: React.RefObject<SVGPathElement | null>;
  horizontalFlip?: boolean;
};

export const ArrowUp = ({ lineMaskRef, arrowMaskRef, horizontalFlip }: ArrowProps) => {
  const maskId = useId();

  return (
    <svg
      width="55.75238"
      height="62.96347"
      viewBox="0 0 55.75238 62.96347"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx({ [styles['horizontal-flip']]: horizontalFlip })}
    >
      <mask id={`mask-${maskId}`} className={styles.mask}>
        <path
          ref={lineMaskRef}
          className={styles.line}
          d="M 54.755203,62.888673 C 50.417953,4.8929367 6.9504226,39.767471 23.863503,47.505985 31.103493,50.81862 32.391993,26.77543 2.1218626,2.8825757"
        />
        <path
          ref={arrowMaskRef}
          className={styles.arrow}
          d="M 1.9792426,11.119013 0.99997264,1.9834727 9.9332226,1.0000007"
        />
      </mask>
      <path
        className={clsx(styles.line, styles.dashed)}
        d="M 54.755203,62.888673 C 50.417953,4.8929367 6.9504226,39.767471 23.863503,47.505985 31.103493,50.81862 32.391993,26.77543 2.1218626,2.8825757"
        mask={`url(#mask-${maskId})`}
      />
      <path
        className={styles.arrow}
        d="M 1.9792426,11.119013 0.99997264,1.9834727 9.9332226,1.0000007"
        mask={`url(#mask-${maskId})`}
      />
    </svg>
  );
};

export const ArrowDown = ({ lineMaskRef, arrowMaskRef, horizontalFlip }: ArrowProps) => {
  const maskId = useId();

  return (
    <svg
      width="53.245605"
      height="83.095726"
      viewBox="0 0 53.245605 83.095726"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx({ [styles['horizontal-flip']]: horizontalFlip })}
    >
      <mask id={`mask-${maskId}`} className={styles.mask}>
        <path
          ref={lineMaskRef}
          className={styles.line}
          d="M 51.11219,0.20114086 C 61.17627,49.197567 0.48004002,33.160878 16.80075,20.090535 31.86027,8.0302109 35.90561,62.803103 1.07455,79.3793"
        />
        <path
          ref={arrowMaskRef}
          className={styles.arrow}
          d="M 3.75043,70.789555 0.99998002,79.422648 9.69553,82.095728"
        />
      </mask>

      <path
        className={clsx(styles.line, styles.dashed)}
        d="M 51.11219,0.20114086 C 61.17627,49.197567 0.48004002,33.160878 16.80075,20.090535 31.86027,8.0302109 35.90561,62.803103 1.07455,79.3793"
        mask={`url(#mask-${maskId})`}
      />
      <path
        className={styles.arrow}
        d="M 3.75043,70.789555 0.99998002,79.422648 9.69553,82.095728"
        mask={`url(#mask-${maskId})`}
      />
    </svg>
  );
};

export const ArrowLeft = ({ lineMaskRef, arrowMaskRef, horizontalFlip }: ArrowProps) => {
  const maskId = useId();

  return (
    <svg
      width="138.11964"
      height="72.313728"
      viewBox="0 0 138.11964 72.313728"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx({ [styles['horizontal-flip']]: horizontalFlip })}
    >
      <mask id={`mask-${maskId}`} className={styles.mask}>
        <path
          ref={lineMaskRef}
          className={styles.line}
          d="M 137.20022,71.920441 C 98.125702,-19.537413 44.945615,53.011412 76.726532,52.903562 103.52818,52.812609 75.190772,-3.6499913 1.529102,8.1351187"
        />
        <path
          ref={arrowMaskRef}
          className={styles.arrow}
          d="M 6.380386,1.0000007 0.99995997,8.1639587 8.13129,13.521313"
        />
      </mask>
      <path
        className={clsx(styles.line, styles.dashed)}
        d="M 137.20022,71.920441 C 98.125702,-19.537413 44.945615,53.011412 76.726532,52.903562 103.52818,52.812609 75.190772,-3.6499913 1.529102,8.1351187"
        mask={`url(#mask-${maskId})`}
      />
      <path
        className={styles.arrow}
        d="M 6.380386,1.0000007 0.99995997,8.1639587 8.13129,13.521313"
        mask={`url(#mask-${maskId})`}
      />
    </svg>
  );
};

export const ArrowRight = ({ lineMaskRef, arrowMaskRef, horizontalFlip }: ArrowProps) => {
  const maskId = useId();

  return (
    <svg
      width="108.96027"
      height="56.323273"
      viewBox="0 0 108.96027 56.323273"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx({ [styles['horizontal-flip']]: horizontalFlip })}
    >
      <mask id={`mask-${maskId}`} className={styles.mask}>
        <path
          ref={lineMaskRef}
          className={styles.line}
          d="M 0.10277816,8.206424 C 46.286118,3.420724 51.701398,71.166064 31.826018,51.927779 17.615528,38.172797 51.152208,0.38702901 107.15907,8.155504"
        />
        <path ref={arrowMaskRef} className={styles.arrow} d="m 102.60738,1 5.35292,7.109179 -6.98146,5.473871" />
      </mask>
      <path
        className={clsx(styles.line, styles.dashed)}
        d="M 0.10277816,8.206424 C 46.286118,3.420724 51.701398,71.166064 31.826018,51.927779 17.615528,38.172797 51.152208,0.38702901 107.15907,8.155504"
        mask={`url(#mask-${maskId})`}
      />
      <path
        className={styles.arrow}
        d="m 102.60738,1 5.35292,7.109179 -6.98146,5.473871"
        mask={`url(#mask-${maskId})`}
      />
    </svg>
  );
};
